import { render, staticRenderFns } from "./CodeInput.vue?vue&type=template&id=070f8a2e&"
import script from "./CodeInput.vue?vue&type=script&lang=ts&"
export * from "./CodeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports